"use client";
import React, { memo, useCallback, useEffect, useState } from "react";
import { AppTextField } from "@/common";
import { AppConstant } from "@/const";
import { TextFieldProps } from "@mui/material";
import { CommonUtils } from "@/utils";
import { SearchIcon } from "@/icons";

const AppSearchDebounceTextFiled = (props: AppSearchDebounceTextFiledProps) => {
  const { onChangeValue, valueInput, hasEndIcon = true, ...otherProps } = props;

  const [value, setValue] = useState<string | number>("");

  const handleChangeValueDebounce = useCallback(
    CommonUtils.debounce((newValue) => {
      if (onChangeValue instanceof Function) onChangeValue(newValue);
    }, AppConstant.DEBOUNCE_TIME_IN_MILLISECOND),
    [onChangeValue]
  );

  const handleChangeValue = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      const newValue = event.target.value;
      setValue(newValue);

      handleChangeValueDebounce(newValue);
    },
    [handleChangeValueDebounce]
  );

  useEffect(() => {
    setValue(valueInput ?? "");
  }, [valueInput]);

  return (
    <AppTextField
      value={value}
      onChange={handleChangeValue}
      InputProps={
        hasEndIcon
          ? {
              endAdornment: <SearchIcon sx={{ fontSize: 24 }} />,
            }
          : {}
      }
      {...otherProps}
    />
  );
};

type AppSearchDebounceTextFiledProps = TextFieldProps & {
  valueInput?: string | number;
  onChangeValue?: (value: string) => void;
  hasEndIcon?: boolean;
};

export default memo(AppSearchDebounceTextFiled);
